import { useInstance } from 'intact-vue-next';
import { eachChildren, isComponentVNode, last } from '../utils';
import { EMPTY_OBJ } from 'intact-shared';
import { OptionGroup } from './group';
import { useState } from '../../hooks/useState';
export function useCard(defaultActiveIndex) {
  var children = useInstance().get('children');
  var activeIndex = useState(last(defaultActiveIndex.value) || 0);
  function process(children) {
    var groupLabels = [];
    var _children = [];
    var index = 0;
    eachChildren(children, function (vNode) {
      if (isComponentVNode(vNode, OptionGroup)) {
        var props = vNode.props || EMPTY_OBJ;
        var label = (props.$blocks || EMPTY_OBJ).label || props.label;
        groupLabels.push(label);
        if (index === activeIndex.value) {
          _children.push(vNode);
        }
        index++;
      } else {
        _children.push(vNode);
      }
    });
    return {
      labels: groupLabels,
      group: _children
    };
  }
  return {
    process: process,
    activeIndex: activeIndex
  };
}